import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";
import { displayName, roleName, capitalize } from "./helpers/presentation.js";
import {
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from "material-ui/List";
import { lightGreen, grey } from "material-ui/colors";
import { withRouter } from "react-router-dom";
import moment from "moment";

const styles = theme => ({
  avatar: {
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 6,
    marginBottom: 8,
    marginLeft: 12
  },
  secondary: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginRight: 16
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row"
  },
  inactive: {
    backgroundColor: grey["400"],
    fontSize: 18
  },
  active: {
    backgroundColor: lightGreen["A700"],
    fontSize: 18
  }
});

const UserListItem = props => {
  const { classes, user, onEditUser, showRole } = props;

  const displayNameWithOptionalRole = () => {
    return showRole
      ? `${displayName(user)} [${roleName(user.role, true)}]`
      : displayName(user);
  };

  return (
    <div>
      <ListItem button divider dense onClick={onEditUser}>
        <ListItemText
          primary={displayNameWithOptionalRole()}
          secondary={user.email}
        />
        <ListItemSecondaryAction>
          <div className={classes.secondary}>
            <div className={classes.statusRow}>
              <Typography type="caption" align="right">
                {capitalize(user.status)}
              </Typography>
              <Avatar className={`${classes[user.status]} ${classes.avatar}`} />
            </div>
            <Typography type="caption" align="right">
              {moment(user.createdOn).format("MMMM Do, YYYY")}
            </Typography>
          </div>
        </ListItemSecondaryAction>
      </ListItem>
    </div>
  );
};

UserListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  showRole: PropTypes.bool.isRequired,
  onEditUser: PropTypes.func.isRequired
};

export default withStyles(styles, { name: "UserListItem" })(
  withRouter(UserListItem)
);



// WEBPACK FOOTER //
// ./src/UserListItem.js